// @ts-check

import React from 'react';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

// New mixer label
const useStyles1 = makeStyles((theme) => ({
  root: {
    padding: "5px 10px",
    overflow: "hidden",
    // @ts-ignore
    width: props => `${props.mixerValue}%`,
    // @ts-ignore
    backgroundColor: props => props.color,
    border: "1px solid #494949",
    minWidth: "0px"
  },
  text: {
    // @ts-ignore
    color: props => theme.palette.getContrastText(props.color),
    fontSize: ".75rem",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
}))

function NewMixerLabel({ id, index, mixerValue, color, name = "" }) {
  const Styles = useStyles1({
    mixerValue: mixerValue,
    color: color
  })

  return (
    <Box className={Styles.root}>
      <Typography className={Styles.text} align="center"> {name === "" ? `Type ${index}` : name}</Typography>
      <Typography className={Styles.text} align="center">{parseInt(mixerValue)}%</Typography>
    </Box>
  )
}


// Custom thumb component
function CustomThumb(props) {

  return (
    <span {...props}>
      <ArrowDropDownIcon fontSize="large" htmlColor="#494949" />
    </span>
  )
}

export { NewMixerLabel, CustomThumb };